
// ページ初期表示のアニメーション

export default function splash() {
  const splash = document.querySelector('.js-header');
  splash.classList.add('-splash-waited');

  document.addEventListener("DOMContentLoaded", function() {
    setTimeout(()=>{
      splash.classList.remove('-splash-waited');
    }, 0);
  });
}

splash();
